import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit', 'amount', 'recapAmount', 'recapTotal'];

  static values = {
    placeholder: { type: String, default: '—' },
  };

  connect() {
    this.sync();
  }

  sync() {
    this.submitTarget.disabled = !this.element.checkValidity();
    this.#updateRecap();
  }

  #updateRecap() {
    if (!this.hasAmountTarget) return;

    const formatted = this.#formatAmount(this.amountTarget.value);
    if (this.hasRecapAmountTarget) this.recapAmountTarget.textContent = formatted;
    if (this.hasRecapTotalTarget) this.recapTotalTarget.textContent = formatted;
  }

  #formatAmount(rawValue) {
    const amount = Number.parseFloat(rawValue);
    if (!Number.isFinite(amount) || amount <= 0) return this.placeholderValue;

    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    });

    return formatter.format(amount);
  }
}
